<template>
  <div class="row product-content-infowrap" v-if="hasData()">
    <div class="col-sm-6 product-content-infoimagewrap" v-if="product.sharedFile && product.sharedFile[imageIndex]">
       <div class="product-content-infoimage lazy match-row" v-lazy:background-image="baseDomain + shopId + '/files/' + product.sharedFile[imageIndex].id + '.' + encodeURI((product.sharedFile[imageIndex].filename.split('.').pop() ? product.sharedFile[imageIndex].filename.split('.').pop() : 'jpg'))"><img class="js-product-printinfoimage product-content-printinfoimage visible-print-block" :src="baseDomain + shopId + '/files/' + product.sharedFile[imageIndex].id + '.' + encodeURI((product.sharedFile[imageIndex].filename.split('.').pop() ? product.sharedFile[imageIndex].filename.split('.').pop() : 'jpg'))" /></div>
    </div>
    <div class="col-xs-12 product-content-infotext match-row" v-if="isMerchantInfoVisible">
      <div class="product-content-infoblock">
        <h3 class="product-content-infotitle js-product-classhereifneedssomethingforbackendpurposes">{{ title }}</h3>
        <div class="product-content-infotable">
          <div class="product-content-inforow">
            <div class="product-content-infovalue">
              {{ companyName }}<br/>
              {{ shopEmail }}<br/>
              {{ shopPhone }}<br/>
              {{ _('Company id:') }} {{ merchant.companyid }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import VueLazyLoad from 'vue3-lazyload'

// Vue.use(VueLazyLoad)

export default {
  data () {
    return {
      imageIndex: this.$store.state.imageIndex
    }
  },
  computed: {
    title () {
      return this._('Enquiries')
    },
    isMerchantInfoVisible () {
      const hostSettings = this.$store.state.settings[this.$store.state.shopId + '-' + this.locale]
        || this.$store.state.settings[this.$store.state.shopId + '-' + (this.$store.state.locales && this.$store.state.locales[0])]
        || {}
      const mode = parseInt(hostSettings.hideshopfromlocal, 10) || 0
      if (mode === 2) {
        return false
      }
      if (this.$store.state.shopId !== this.shopId) {
        return true
      }
      return mode !== 1
    },
    merchant () {
      if(this.$store.state.settings[this.shopId + '-' + this.locale]) {
        return this.$store.state.settings[this.shopId + '-' + this.locale]
      } else {
        for(let i = 0; i < this.$store.state.locales.length; i++) {
          if(this.$store.state.settings[this.shopId + '-' + this.$store.state.locales[i]]) {
            return this.$store.state.settings[this.shopId + '-' + this.$store.state.locales[i]]
          }
        }
      }
      return {}
    },
    companyName () {
      return this.merchant.marketingname || this.merchant.companyname
    },
    shopEmail () {
      return this.merchant.shopemail || this.merchant.companyemail
    },
    shopPhone () {
      return this.merchant.shopphone || this.merchant.companyphone
    }
  },
  props: ['product', 'fields', 'baseDomain', 'shopId', 'locale'],
  methods: {
    hasData () {
      return true
    }
  },
  created: async function () {
    await this.$store.dispatch('setImageIndex', this.$store.state.imageIndex + 1)
  }
}
</script>
